<template>
  <div class="SectionDateSearchPanel">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row class="mt-2">
          <v-col cols="12" sm="6">
            <v-row>
              <v-col sm="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("date") }} : </label>
              </v-col>
              <v-col>
                <dialog-date-picker
                  :label="$t('date') + ':'"
                  :initDate="initBeginDate"
                  @dateResult="bDate"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row class="mt-2 mt-sm-0">
              <v-col class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("sectionType") }} : </label>
              </v-col>
              <v-col>
                <v-select
                  hide-details
                  v-model="sectionType"
                  :items="sectionTypes"
                  :label="$t('sectionType')"
                  item-text="Name"
                  item-value="Code"
                  return-object
                  dense
                  solo
                  v-on:change="changeSectionType"
                  class="my-auto py-0"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-card-actions class="px-0 pt-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
import DialogDatePicker from "../widget/DialogDatePicker.vue";
export default {
  components: { DialogDatePicker },
  props: { accessTo: String },
  data() {
    return {
      initBeginDate: null,
      beginDate: "",
      sectionType: "",
      sectionTypes: [],
    };
  },
  mounted() {
    this.sectionTypes = [];
    if (EosUtils.isWebKartAdmin()) {
      this.getAllSection();
    } else if (this.accessTo) {
      this.getSectionWithPermissionNumber();
    } else {
      this.getSectionTypes();
    }
  },

  methods: {
    bDate(date) {
      this.beginDate = date;
      this.search();
    },
    getAllSection() {
      this.sectionTypes.push({ Name: this.$t("allSection"), Code: "0" });

      this.$store.dispatch("sections/GetAllSections").then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.search();
        } else {
          this.sectionTypes.splice(0);
        }
      });
    },
    async getSectionWithPermissionNumber() {
      var params = new URLSearchParams();
      params.append("accessTo", this.accessTo);

      //this.sectionTypes.push({ Name: this.$t("allSection"), Code: "-1" });

      this.$store
        .dispatch("sections/GetSectionsList", { params })
        .then((result) => {
          debugger
          ////console.log(result);
          if (result.type == ResultType.success) {
            let resultCode=(result.data[0].Code).trim();
            if(resultCode=='-1'){
              this.getAllSection();
            }
            else{
              this.sectionTypes.push(...result.data);
            if (this.sectionTypes.length > 0) {
              this.sectionType = this.sectionTypes[0];
            }

            this.search();

            }
           
          } else {
            this.sectionTypes.splice(0);
          }
        });
    },

    async getSectionTypes() {
      var IsFreeOfGroupManager = false;
      await this.$store.dispatch("IsFreeOfGroupManager").then((result) => {
        if (result.type === ResultType.success) {
          IsFreeOfGroupManager = result.data;
        }
      });

      if (IsFreeOfGroupManager) {
        this.$store.dispatch("sections/GetAllSections").then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            this.sectionTypes.push(...result.data);
            if (this.sectionTypes.length > 0) {
              this.sectionType = this.sectionTypes[0];
            }

            this.search();
          }
        });
      } else {
        this.$store
          .dispatch("sections/GetDedicatedSectionForPersentPessonel")
          .then((result) => {
            ////console.log(result);
            if (result.type == ResultType.success) {
              this.sectionTypes.push(...result.data);
              if (this.sectionTypes.length > 0) {
                this.sectionType = this.sectionTypes[0];
              }

              this.search();
            }
          });
      }
    },

    changeSectionType() {
      this.search();
    },
    search() {
      if (!this.sectionType?.Code || !this.beginDate) {
        return;
      }
      var searchParams = {
        sectionCode: this.sectionType?.Code?.toString().trim(),
        iDate: this.beginDate,
      };

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
}

::v-deep .management-checkbox .v-label {
  font-size: 0.9rem;
  text-align: right;
}

.max-width-text-title {
  max-width: 90px;
}
</style>
